// Environment variable validation and typing
interface Env {
  MAKE_WEBHOOK_URL: string;
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  STRIPE_PUBLISHABLE_KEY: string;
}

// Default values for development
const defaults: Env = {
  MAKE_WEBHOOK_URL: 'https://hook.us2.make.com/7vdfq1nk97vvwx2d8h9p72qqb5rsogg4',
  SUPABASE_URL: 'https://uadvgxhgbnllpoucdtbc.supabase.co',
  SUPABASE_ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVhZHZneGhnYm5sbHBvdWNkdGJjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU3NjM2NzQsImV4cCI6MjA1MTMzOTY3NH0.aRDqM0Y1vL_JQvHXJhX2jkVPslQQi5yGBa7MKCxiPZk',
  STRIPE_PUBLISHABLE_KEY: 'pk_live_51QXkg2CBvNoqu9Zw07ddpO7Iy1T7ylUZ43cq1QnZi6kpZdFyb6HFj9ztaRmjqjLsgbgQr8hP2WsJRcD9iLm3wxih00YYpEeISy'
};

// Get environment variables with fallbacks
export const ENV: Env = {
  MAKE_WEBHOOK_URL: import.meta.env.VITE_MAKE_WEBHOOK_URL || defaults.MAKE_WEBHOOK_URL,
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || defaults.SUPABASE_URL,
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || defaults.SUPABASE_ANON_KEY,
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || defaults.STRIPE_PUBLISHABLE_KEY
};

export function validateEnvironment(): void {
  const missing = Object.entries(ENV)
    .filter(([_, value]) => !value)
    .map(([key]) => key);

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}`
    );
  }
}